module.exports = __webpack_public_path__ + "static/media/smile-girl-2x.50fb352d.png";